import { React } from "react";

const FooterComponent = () => {
  return (
    <>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-xs-12 footer-col-spacing">
              <a className="navbar-brand" href="/">
                <img
                  src={
                    process.env.PUBLIC_URL + "/images/mim-logo.png"
                  }
                  alt="mim"
                  className="w-[100px] h-auto"
                />
              </a>
            </div>
            <div className="col-md-4 col-xs-12 footer-col-spacing footer-nav-links">
              <ul className="list-unstyled">
                <li className="footer-item footer-links-col-1">
                  <a
                    className="footer-link"
                    href="https://www.mim.ac/product"
                  >
                    Product
                  </a>
                </li>
                <li className="footer-item footer-links-col-1">
                  <a
                    className="footer-link"
                    href="https://www.mim.ac/case-studies"
                  >
                    Case Studies
                  </a>
                </li>
                <li className="footer-item footer-links-col-1">
                  <a
                    className="footer-link"
                    href="https://www.mim.ac/request-demo"
                  >
                    Request Demo
                  </a>
                </li>
                <li className="footer-item footer-links-col-1">
                  <a
                    className="footer-link"
                    href="https://www.mim.ac/support"
                  >
                    Support
                  </a>
                </li>
                <li className="footer-item footer-links-col-1">
                  <a className="footer-link" href="https://www.mim.ac/about">
                    About
                  </a>
                </li>

                <hr className="clearfix w-100 footer-hr" />

                <li className="footer-item footer-links-col-1">
                  <a
                    className="footer-link"
                    href="https://www.mim.ac/privacy-policy"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li className="footer-item footer-links-col-1">
                  <a className="footer-link" href="https://www.mim.ac/eula">
                    EULA
                  </a>
                </li>
                <li className="footer-item footer-links-col-1">
                  <a
                    className="footer-link"
                    href="https://www.mim.ac/acceptable-use"
                  >
                    Acceptable Use
                  </a>
                </li>
                <li className="footer-item footer-links-col-1">
                  <a
                    className="footer-link"
                    href="https://www.mim.ac/accessibility"
                  >
                    Accessibility
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-4 col-xs-12 footer-col-spacing">
              <h5 className="text-capitalized">Connect with us</h5>
              <a className="mb-4 footer-email" href="mailto: hello@mim.ac">
                hello@mim.ac
              </a>
              <ul className="list-inline social-icons">
                <li className="py-1 list-inline-item">
                  <a
                    href="https://www.linkedin.com/company/mim-ac/"
                    className="fab fa-lg fa-linkedin"
                    aria-hidden="true"
                  >
                    LinkedIn
                  </a>
                </li>
                <li className="py-1 list-inline-item">
                  <a
                    href="https://www.facebook.com/mimac/"
                    className="fab fa-lg fa-facebook-square"
                    aria-hidden="true"
                  >
                    Facebook
                  </a>
                </li>
                <li className="py-1 list-inline-item">
                  <a
                    href="https://twitter.com/mim_ac"
                    className="fab fa-lg fa-twitter-square"
                    aria-hidden="true"
                  >
                    Twitter
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="row footer-copyright">
            <div className="col-md-2 mr-auto">
              <div>
                <span>© mim 2022</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterComponent;
